import { Box, Typography } from "@mui/material";
import React from "react";

import { theme } from "../../utils/theme";

const Section = ({ title, children }) => {
  return (
    <Box sx={{ mb: 6 }}>
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          fontSize: theme.typography.h3,
          fontWeight: 600,
          letterSpacing: 0.9,
 
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{ color: theme.palette.grays[900], fontSize: theme.typography.h5 }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default Section;
